module.exports = __webpack_public_path__ + "img/worksbot_img20021115.1d7d5877.jpg";